import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageToggle } from "@/coquille-bridge";
import { AppBackground } from "@/components/AppBackground.jsx";
import { PWSVersionBar } from "@/components/PWSVersionBar.jsx";
import { OfficialLogo } from "@/components/OfficialLogo.jsx";
import { PasswordField } from "@/components/PasswordField.jsx";
import { apiJson } from "@/api/client.js";
import { useAuth } from "@/context/AuthContext.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function LoginPage() {
  const { ui } = useOrignalUi();
  const { login, refreshMe } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("marcel");
  const [password, setPassword] = useState("orignal2026");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [mustChange, setMustChange] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [done, setDone] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await login(username.trim().toLowerCase(), password);
      if (user?.must_change_password) {
        setMustChange(true);
        setCurrent(password);
        return;
      }
      navigate("/");
    } catch {
      setError(ui.errors.login);
    } finally {
      setBusy(false);
    }
  }

  async function onChangePassword(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await apiJson("/api/auth/change-password", { current_password: current, new_password: next });
      await refreshMe();
      setDone(ui.app.passwordChanged);
      setTimeout(() => navigate("/"), 700);
    } catch {
      setError(ui.errors.login);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="og-login" data-testid="page-login" data-surface="dark">
      <AppBackground />
      <div className="og-login__card">
        <div className="og-login__top">
          <OfficialLogo size="login" />
          <p className="og-kicker">PWS</p>
          <h1>{ui.app.name}</h1>
          <p>{ui.app.tagline}</p>
          <LanguageToggle testId="orignal-language-toggle" />
        </div>
        {mustChange ? (
          <form onSubmit={onChangePassword} className="og-form" data-testid="password-step">
            <p>{ui.app.changePassword}</p>
            <PasswordField label={ui.app.currentPassword} value={current} onChange={setCurrent} testId="login-current" showLabel={ui.app.showPassword} hideLabel={ui.app.hidePassword} />
            <PasswordField label={ui.app.newPassword} value={next} onChange={setNext} testId="login-new" autoComplete="new-password" showLabel={ui.app.showPassword} hideLabel={ui.app.hidePassword} />
            {error ? <p className="og-error">{error}</p> : null}
            {done ? <p className="og-hint">{done}</p> : null}
            <button className="og-btn og-btn--primary" type="submit" disabled={busy}>{ui.app.save}</button>
          </form>
        ) : (
          <form onSubmit={onSubmit} className="og-form">
            <label>
              {ui.app.username}
              <input className="og-input" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="login-username" autoComplete="username" />
            </label>
            <PasswordField label={ui.app.password} value={password} onChange={setPassword} testId="login-password" showLabel={ui.app.showPassword} hideLabel={ui.app.hidePassword} />
            {error ? <p className="og-error" data-testid="login-error">{error}</p> : null}
            <button className="og-btn og-btn--primary" type="submit" data-testid="login-submit" disabled={busy}>
              {busy ? ui.app.loading : ui.app.signIn}
            </button>
            <p className="og-hint">{ui.app.loginHint}</p>
          </form>
        )}
      </div>
      <PWSVersionBar />
    </div>
  );
}
